import { IBookingSessionAvailability } from './booking/types';

export const getFirstAvailableDate = (availability: IBookingSessionAvailability) => {
    const dates = Object.keys(availability);

    for (const date of dates) {
        if (availability[date].length > 0) {
            return date;
        }
    }

    return null;
};

export const formatDateToString = (date: Date): string => {
    /* We do not use the toIsoString method here because it uses UTC time
     * as an offset. This does not work well with all timezones. Therefore,
     * we want to manually set our date formats.
     */
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
